import * as Yup from 'yup';

export const CustomerMembershipSchema = Yup.object().shape({
  freeze: Yup.string().required('Select option').typeError('Select option'),
  freezeExpires: Yup.string().when('freeze', {
    is: '1',
    then: Yup.string()
      .required('Select Date & Time')
      .typeError('Select Date & Time'),
    otherwise: Yup.string().nullable(true)
  })
});
